import { render, staticRenderFns } from "./NotesDialog.vue?vue&type=template&id=daff557e&scoped=true&lang=pug&"
import script from "./NotesDialog.vue?vue&type=script&lang=ts&"
export * from "./NotesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NotesDialog.vue?vue&type=style&index=0&id=daff557e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daff557e",
  null
  
)

export default component.exports